import { useTranslation } from 'react-i18next';
import { Container, Grid, Box, Typography, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import SchoolIcon from '@mui/icons-material/School';
import MosqueIcon from '@mui/icons-material/Mosque';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FactoryIcon from '@mui/icons-material/Factory';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Section, SectionTitle, AnimatedBox } from '../../components/ui';

const IndustryCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(4, 3),
  borderRadius: '16px',
  backgroundColor: '#FFFFFF',
  border: '1px solid rgba(0, 0, 0, 0.06)',
  transition: 'all 0.3s ease',
  cursor: 'pointer',

  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
    borderColor: 'transparent',

    '& .industry-icon': {
      background: theme.palette.accent.gradient,
      color: '#FFFFFF',
      transform: 'scale(1.1)',
    },
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: '72px',
  height: '72px',
  borderRadius: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(91, 141, 239, 0.1) 100%)',
  color: theme.palette.primary.main,
  transition: 'all 0.3s ease',

  '& svg': {
    fontSize: '32px',
  },
}));

const industries = [
  { key: 'automotive', icon: <DirectionsCarIcon /> },
  { key: 'healthcare', icon: <LocalHospitalIcon /> },
  { key: 'education', icon: <SchoolIcon /> },
  { key: 'religious', icon: <MosqueIcon /> },
  { key: 'retail', icon: <ShoppingCartIcon /> },
  { key: 'manufacturing', icon: <FactoryIcon /> },
  { key: 'finance', icon: <AccountBalanceIcon /> },
  { key: 'logistics', icon: <LocalShippingIcon /> },
];

export default function IndustriesSection() {
  const { t } = useTranslation();

  return (
    <Section variant="light">
      <Container maxWidth="lg">
        <SectionTitle
          title={t('industries.title')}
          subtitle={t('industries.subtitle')}
        />

        <Grid container spacing={3}>
          {industries.map((industry, index) => (
            <Grid item xs={6} sm={4} md={3} key={industry.key}>
              <AnimatedBox
                animation="fadeInUp"
                delay={`${index * 0.08}s`}
                sx={{ height: '100%' }}
              >
                <IndustryCard>
                  <IconWrapper className="industry-icon">
                    {industry.icon}
                  </IconWrapper>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      textAlign: 'center',
                      color: 'text.primary',
                    }}
                  >
                    {t(`industries.${industry.key}`)}
                  </Typography>
                </IndustryCard>
              </AnimatedBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}
